import en from './locales/en'
import it from './locales/it'

export default {
  en,
  it,
}
